
export class Roles {
    public static readonly Planner = 'SafeDigs.Planning';
    public static readonly Safedigs = 'SafeDigs.Default';
    public static readonly Hotjobs = 'HotJobs.Default';
    public static readonly Noticing = 'Noticing.Default';
}